<template>
  <div v-if="visitSource == 2" class="kw_tabs" :style="tabsBoxStyleSet" kwName="listPageTabsBoxCommonStyleSet">
    <div v-if="(type)">
      <!-- 带滚动条的div -->
      <div ref="kw_tabs" :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" v-if="(scroll)" scroll-x="true" :class="('i-class-'+type)+' '+('i-tabs-'+type)+' '+('i-tabs-scroll-'+type)+' '+( fixed ? 'i-tabs-fixed-'+type : '' )"><slot></slot></div>
      <div ref="kw_tabs" v-else :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" :class="('i-class-'+type)+' '+('i-tabs-'+type)+' '+( fixed ? 'i-tabs-fixed-'+type : '' )"><slot></slot></div>
    </div>
    <div v-else>
      <!-- 带滚动条的div -->
      <div ref="kw_tabs" :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" v-if="(scroll)" scroll-x="true" :class="'i-class i-tabs_pc i-tabs-scroll '+( fixed ? 'i-tabs-fixed' : '' )"><slot></slot></div>
      <div ref="kw_tabs" v-else :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" :class="'i-class i-tabs_pc '+( fixed ? 'i-tabs-fixed' : '' )"><slot></slot></div>
    </div>

  </div> 

  <div v-else class="kw_tabs" :style="tabsBoxStyleSet" kwName="listPageTabsBoxCommonStyleSet">
    <div v-if="(type)">
      <!-- 带滚动条的div -->
      <div ref="kw_tabs" :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" v-if="(scroll)" scroll-x="true" :class="('i-class-'+type)+' '+('i-tabs-'+type)+' '+('i-tabs-scroll-'+type)+' '+( fixed ? 'i-tabs-fixed-'+type : '' )"><slot></slot></div>
      <div ref="kw_tabs" v-else :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" :class="('i-class-'+type)+' '+('i-tabs-'+type)+' '+( fixed ? 'i-tabs-fixed-'+type : '' )"><slot></slot></div>
    </div>
    <div v-else>
      <!-- 带滚动条的div -->
      <div ref="kw_tabs" :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" v-if="(scroll)" scroll-x="true" :class="'i-class i-tabs i-tabs-scroll '+( fixed ? 'i-tabs-fixed' : '' )"><slot></slot></div>
      <div ref="kw_tabs" v-else :style="tabsStyleSet" kwName="listPageTabsCommonStyleSet" :class="'i-class i-tabs '+( fixed ? 'i-tabs-fixed' : '' )"><slot></slot></div>
    </div>

  </div>
</template>

<script>
  import utils from '@/js/utils/util.js';
export default {
  name: 'kw_tabs',
  props: {
    value: {
        default: ''
    },
    index:{
        default: ''
    },
    color: {
        type: String,
        default: ''
    },
    scroll: {
        type: Boolean,
        default: false
    },
    fixed: {
        type: Boolean,
        default: false
    },
    multiple:{
        type: Number,
        default: 1
    },
    align: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    bg: {
      type: String,
      default: ''
    },
    radius: {
      type: String,
      default: ''
    },
    padding: {
      type: String,
      default: ''
    },
    margin: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    display: {
      type: String,
      default: ''
    },
    tabsBoxStyleSet: {
      type: String,
      value: ''
    },
    tabsStyleSet: {
      type: String,
      value: ''
    }
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      myValue:this.value,
      currentArr: []
    };
  },
  created() {
     
  },
  mounted() {
     var childSlot = this.$slots.default;
     var value = this.value;
     if(childSlot) {
       var currentArr = [];
        childSlot.forEach(item => {
            if(this.multiple != 1){
              var flag = ("," + value + ",").indexOf("," + item.child.name + ",") >= 0;
              if (flag) {
                currentArr.push(item.child);
              }
            }
        });
        this.currentArr = currentArr;
     }
  },
  watch:{
    value(newVal) {
      this.myValue = newVal
    },
    myValue(newVal) {
      console.log("myValue 切换=======================",newVal);
      this.$emit('input', newVal);
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    emitEvent (child) {
      var that = this;
      if (this.multiple != 1) {
        var currentArr = this.currentArr;
        var newCurrentArr = [];
        if (("," + this.value + ",").indexOf("," + child.name + ",") >= 0) {
          currentArr.forEach(item=>{
            if(item.name != child.name) {
              newCurrentArr.push(item);
            }
          })

        } else {
          currentArr.push(child);
          newCurrentArr = currentArr;
        }
        var newValue = "";
        newCurrentArr.forEach(item=>{
          if(newValue != "") {
            newValue+=",";
          }
          newValue+=item.name;
        })
        this.myValue = newValue;
        this.currentArr = newCurrentArr;
        this.$nextTick(function(){
          that.$emit('change', that.currentArr,that.index);
        });
      } else {
        this.myValue = child.name+"";
        this.$nextTick(function(){
          that.$emit('change', child,that.index);
        });
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.i-tabs{display:flex;width:100%;height:42px;line-height:42px;box-sizing:border-box;position:relative;justify-content:space-around;align-items:center;-webkit-box-align:center;background:#fff}.i-tabs::after{content:'';position:absolute;top:0;left:0;width:200%;height:200%;transform:scale(.5);transform-origin:0 0;pointer-events:none;box-sizing:border-box;border:0 solid #e9eaec;border-bottom-width:1px}.i-tabs-scroll{display:block;overflow-x:auto;white-space:nowrap}.i-tabs-fixed{position:fixed;top:0;z-index:2}
.i-tabs_pc{display:flex;width:100%;height:42px;line-height:42px;box-sizing:border-box;position:relative;justify-content:space-around;align-items:center;-webkit-box-align:center;background:#fff}.i-tabs::after{content:'';position:absolute;top:0;left:0;width:200%;height:200%;transform:scale(.5);transform-origin:0 0;pointer-events:none;box-sizing:border-box;border:0 solid #e9eaec;border-bottom-width:1px}.i-tabs-scroll{display:block;overflow-x:auto;white-space:nowrap}.i-tabs-fixed{position:fixed;top:0;z-index:2}

.SearchScroll{background: none !important;}
.i-tabs{background: #fff; height: auto; line-height: 1rem; overflow: auto;}
.i-tabs_pc{background: #fff; height: auto; overflow: auto;}
.i-tabs::after{display: none;}
.i-tabs_pc::after{display: none;}


/* **************************** menu ********************************** */

.i-tabs-menu{display:flex;width:100%;height:42px;line-height:42px;box-sizing:border-box;position:relative;align-items:center;-webkit-box-align:center;background:#fff;flex-wrap: wrap}
.i-tabs-menu::after{content:'';position:absolute;top:0;left:0;width:200%;height:200%;transform:scale(.5);transform-origin:0 0;pointer-events:none;box-sizing:border-box;border:0 solid #e9eaec;border-bottom-width:1px}
.i-tabs-scroll-menu{display:block;overflow-x:auto;white-space:nowrap}
.i-tabs-fixed-menu{position:fixed;top:0;z-index:2}

.SearchScroll-menu{background: none !important;}
.i-tabs-menu{background: #fff; height: auto; line-height: 1rem; overflow: visible;}
.i-tabs-menu::after{display: none;}

/********************************tabbg*************************************/
.i-tabs-tabbg{display:flex;width:100%;height:42px;line-height:42px;box-sizing:border-box;position:relative;justify-content:space-around;align-items:center;-webkit-box-align:center;background:#fff}
.i-tabs-tabbg::after{content:'';position:absolute;top:0;left:0;width:200%;height:200%;transform:scale(.5);transform-origin:0 0;pointer-events:none;box-sizing:border-box;border:0 solid #e9eaec;border-bottom-width:1px}
.i-tabs-scroll-tabbg{display:block;overflow-x:auto;white-space:nowrap}
.i-tabs-fixed-tabbg{position:fixed;top:0;z-index:2}

.SearchScroll-tabbg{background: none !important;}
.i-tabs-tabbg{background: transparent; height: auto; line-height: 1rem; overflow: visible;}
.i-tabs-tabbg::after{display: none;}
</style>
